import { useState } from "react";

// Copies text to the clipboard; the icon turns into a check mark for a moment
const CopyButton = ({ text, label }: { text: string; label: string }) => {
  const [copied, setCopied] = useState(false);
  const copy = async (e: React.MouseEvent) => {
    // Inside a clickable table row, don't also trigger the row
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Older browsers or a non-secure page: copy through a hidden text box
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <button
      type="button"
      className="btn btn-sm p-0 border-0 ms-1 align-baseline"
      title={copied ? "Copied" : `Copy ${label}`}
      aria-label={copied ? "Copied" : `Copy ${label}`}
      onClick={copy}
      style={{ color: copied ? "#146c43" : "#8a9199", fontSize: "0.85rem", lineHeight: 1 }}
    >
      <i className={`bi ${copied ? "bi-check2" : "bi-copy"}`} />
    </button>
  );
};

export default CopyButton;
